<template>
    <div>

        <div id="contact" class="section">
            <div class="overlay opacity-35"></div>
            <lottie-player
                autoplay
                loop
                mode="normal"
                preserveAspectRatio="xMidYMid slice"
                src="https://cdn.sleepjar.com/sleepsounds/images/backgrounds/7x3/animated/simple/json/StarryMountains.json"
                class="bg-lottie-player"
            />
            <div class="container h-100">
                <div class="d-flex h-100 text-center align-items-center">
                    <div class="w-100 color-white">
                        <h1 class="title color-white mb-10">Contact Us</h1>
                        <div>
                            <form class="text-left" method="post" action="https://formspree.io/f/mbjpvbve">
                                <input type="hidden" name="_subject" value="Inquiry from sleepjar.com">
                                <input type="text" name="_gotcha" style="display:none">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="name">Name</label>
                                            <input type="text" class="form-control" name="name" id="name" value="" placeholder="Enter your name" required>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="email">Email</label>
                                            <input type="email" class="form-control" name="email" id="email" placeholder="Enter your email address" required>
                                        </div>
                                    </div>
                                </div>
                                <div v-show="!this.$route.query.platform || !this.$route.query.app_version" class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="name">App Platform</label>
                                            <select  class="form-control" name="platform" id="platform" placeholder="Choose a platform">
                                                <option :selected="this.$route.query.platform == 'ALEXA'">Alexa</option>
                                                <option :selected="this.$route.query.platform == 'ANDROID'">Android</option>
                                                <option :selected="this.$route.query.platform == 'IOS'">iOS</option>
                                                <option :selected="this.$route.query.platform == 'FIRETV'">Fire TV</option>
                                                <option :selected="this.$route.query.platform == 'OTHER'">Other</option>
                                            </select>
                                            
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="app_version">App Version</label>
                                            <input type="text" class="form-control" name="app_version" id="app_version" :value="this.$route.query.app_version">
                                            <input type="hidden" class="form-control" name="app_build" id="app_build" :value="this.$route.query.app_build">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="message">Message</label>
                                            <textarea id="message" name="message" class="form-control mb-5" rows="9" placeholder="Enter your message..." required></textarea>
                                        </div>
                                    </div>
                                </div>
                                <button type="submit" class="btn btn-outline-light color-white ml-auto mr-auto d-flex pointer"><i class="fas mr-2 fa-paper-plane"></i>Send Message</button>
                            </form>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>


<script>
    export default {
        name: 'contact',
        metaInfo: {
            title: 'Contact Us',
            meta: [
                {
                    'name': 'description',
                    'property': 'og:description',
                    'content': 'Send us your feedback about Sleep Jar® or ask us to add a sound.'
                }
            ]
        },
        data () {
            return {
            };
        },
        methods: {
        },
        computed: {
        },
        components: {
        },
        mounted(){
        }
    }
</script>
